import axios from "axios";
import { Base_URL } from "../url";
import { Base_URL2 } from "../url";

export const saveIncomingPO = async (poRequest) => {
  try {
    const response = await axios.post(
      `${Base_URL}/Invoices/CreateIncomingPO`,
      poRequest,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to save incoming PO";
  }
};

export const saveInvoiceHeader = async (invoiceData) => {
  try {
    const response = await axios.post(
      `${Base_URL}/Invoices/CreateInvoices`,
      invoiceData,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to save invoice header";
  }
};

export const saveInvoiceItems = async (invoiceItemsData) => {
  try {
    const response = await axios.post(
      `${Base_URL}/Invoices/AddInvoiceItems`,
      invoiceItemsData,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to save invoice items";
  }
};

export const fetchCompanyCodes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CompanyCode/GetAll`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch company codes";
  }
};

// New API for getting company data by organization ID
export const getCompanyByOrganisationId = async (organisationId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/CompanyCode/GetByOrganisationId/${organisationId}`
    );


    return response.data.data || response.data.Data || [];
  } catch (error) {
    console.log("Error fetching company codes:", error);
    throw error;
  }
};

export const fetchCustomers = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/CustomerMaster/GetAllCustomers`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch customers";
  }
};

export const fetchProjects = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectMaster/GetAllProjects`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch projects";
  }
};
export const fetchrevenueProjects = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectMaster/GetRevenueAllowedProject`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch projects";
  }
};

export const fetchItems = async () => {
  try {
    const response = await axios.get(`${Base_URL}/Item/ItemGetData`);
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch items";
  }
};

export const fetchItemsByOrgId = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/Item/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch items";
  }
};

export const fetchBatchByItem = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/BatchMaster/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch items";
  }
};

export const fetchResources = async (id) => {
  try {
    const response = await axios.get(
      `${Base_URL}/SalaryProcess/ResourceMasters/${id}`
    );
    console.log("resource", response.data);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch resources";
  }
};

export const fetchVendors = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProVenMapping/GetAllProVenMappings`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch vendors";
  }
};

export const fetchTaxCodes = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/TaxCodesLogistics/GetAllTaxCodes`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch tax codes";
  }
};

export const fetchHSNCodes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/HSN/HsnGetData`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch HSN codes";
  }
};

export const fetchOrgHsn = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/OrganisationMaster/${id}`);
    console.log(response.data);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch Org codes";
  }
};

export const fetchBatchPrice = async (id) => {
  console.log(id, "id");
  try {
    const response = await axios.get(`${Base_URL}/BatchLabelling/${id}`);
    // console.log("Batch data",response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch Org codes";
  }
};
export const fetchgstdetails = async (id, hsn) => {
  try {
    const response = await axios.get(`${Base_URL}/GSTdetermination/${id}`, {
      params: { hsn: hsn }, // explicitly sending as string
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch GST details";
  }
};

export const saveBatch = async (payload) => {
  // payload keys must be: userId, batchId, productCode, mfgDate, expDate
  const res = await axios.post(`${Base_URL}/BatchMaster/CreateBatch`, payload);
  return res.data;
};

export const saveCommitment = async (payload) => {
  const res = await axios.post(`${Base_URL}/CommitmentMaster`, payload);
  return res.data;
};

export const getAllCommitments = async () => {
  const res = await axios.get(`${Base_URL}/CommitmentMaster`);

  return Array.isArray(res.data) ? res.data : res.data?.data || [];
};

export const getCommitmentById = async (id) => {
  const res = await axios.get(`${Base_URL}/CommitmentMaster/${id}`);
  return res.data;
};

export const updateCommitment = async (id, payload) => {
  const res = await axios.put(`${Base_URL}/CommitmentMaster/${id}`, payload);
  return res.data;
};

export const getSalesPerson = async (id) => {
  const res = await axios.get(`${Base_URL}/Resource/GetResourceBySalesPerson/${id}`);
  return res.data;
};


export const fetchCustomerTaxCodes = async (
  customerCode,
  companyCode
) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TaxCodesLogistics/getCustomerTaxCode/${customerCode}/${companyCode}`
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch customer tax codes";
  }
};